import { useDispatch, useSelector } from "react-redux";
import OptionsButtonCustom from "../../../../components/button/OptionsButtonCustom";
import TableRowCommon from "../../../../components/table/TableRowCommon";
import { Box, useMediaQuery, useTheme } from "@mui/material";
import { useCallback, useEffect, useState } from "react";
import SwitchCustom from "../../../../components/switch/SwitchCustom";
import { NavigateFunction, useNavigate } from "react-router-dom";
import { checkPermission, permission_config } from "../../../../utils/app.utils";
import { routeName } from "../../../../routes/routeName";
import { roles_list, RolesApi } from "../../../../api/roles/roles.api";
import { setLoading, unsetLoading } from "../../../../store/loading/loading.slice";
import { RootState } from "../../../../store/store";
import { dateTimeToView } from "../../../../utils/date.utils";
import { useTranslation } from "react-i18next";

export const ManageState = (code: string) => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const navigate: NavigateFunction = useNavigate();

    const profile = useSelector((state: RootState) => state.profile.profile) as any;
    const permission: any[] = profile?.permission || [];
    const checkPermit: permission_config = checkPermission("WEBSITE_STRUCTURE_PERMISSION", permission)


    const theme = useTheme();
    const matches = useMediaQuery(theme.breakpoints.up("md"));
    const [page, setPage] = useState<number>(1);
    const [pageLimit, setPageLimit] = useState<number>(10);
    const [totalItems, setTotalItems] = useState<number>(0);
    const [sortBy, setSortBy] = useState<string>("id_roles");
    const [sortType, setSortType] = useState<string>("DESC")

    const [data, setData] = useState<any[]>([]);

    const handleRequestSort = (sortBy: string, sortType: string) => {
        setSortBy(sortBy)
        setSortType(sortType)
    }


    const headCell = [
        {
            id: "id_roles", width: 50, sortable: true, disablePadding: false, align: 'center', label: t("ลำดับ")
        },
        {
            id: "permission_name", disablePadding: false, width: 150, sortable: true, align: "left", label: t("ชื่อบทบาท")
        },
        {
            id: "employee_count", disablePadding: false, width: 150, sortable: false, align: "center", label: t("จำนวนผู้ใช้งาน")
        },
        {
            id: "status", disablePadding: false, width: 150, sortable: false, align: "left", label: t("สถานะ")
        },
        {
            id: "create_by", disablePadding: false, width: 180, sortable: false, align: "center", label: t("ผู้ที่สร้าง/แก้ไขล่าสุด")
        },
        {
            id: "modified_date", disablePadding: false, width: 180, sortable: false, align: "center", label: t("วันที่สร้าง/แก้ไขล่าสุด")
        },
        {
            id: "action", disablePadding: false, width: 60, class: matches, sortable: false, align: "left", label: ""
        },
    ];

    const renderData = (objData: any, no: any) => {
        no = page * pageLimit - pageLimit + no + 1
        const {
            roles_name,
            id_roles,
            employee_count,
            status,
            // created_by,
            // modified_by,
            modified_date,
            created_date,
            modified_name,
            create_name
        } =
            objData;

        const objRenderData = {
            key: no,
            id: no,
            obj: objData,
            columns: [
                { option: "TEXT", align: "center", label: no || "-" },
                {
                    option: "TEXT",
                    align: "left",
                    label: roles_name || "-",
                },
                {
                    option: "TEXT",
                    align: "center",
                    label: employee_count || 0,
                },
                {
                    option: "TEXT",
                    align: "left",
                    label: <SwitchCustom disabled={!checkPermit.isUpdate} checked={status === 'active'} onChange={(st) => handleChangeStatus(id_roles, st ? "active" : "inactive")} />
                },
                {
                    option: "TEXT",
                    align: "center",
                    label: modified_name || create_name || "-",
                },
                {
                    option: "TEXT",
                    align: "center",
                    label: modified_date ? dateTimeToView(modified_date) : created_date ? dateTimeToView(created_date) : "-",
                },
                {
                    option: "COMPONENT",
                    align: "center",
                    class: matches,
                    component: <Box display={"flex"} justifyContent={"center"}>
                        <OptionsButtonCustom
                            // enableView
                            // enableEdit
                            enableView={checkPermit.isView}
                            enableEdit={checkPermit.isUpdate}
                            // enableDelete
                            onViewClick={() => navigate(routeName.cms_website.permissionDetailView.replace(":id", id_roles))}
                            onEditClick={() => navigate(routeName.cms_website.permissionDetail.replace(":id", id_roles))}
                        // onDeleteClick={() => { }}
                        />
                    </Box>
                },
            ],
        };
        return <TableRowCommon
            {...objRenderData}
        />;
    };


    const handleChangeStatus = async (id_roles: number, status: string) => {
        await RolesApi.updateStatus(id_roles, { status: status, }).then((res) => {
            if (res.status < 300) {
                handleGetData();
            }
        }).catch((err) => {
            console.log(err)
        })
    }

    const handleGetData = useCallback(async () => {
        let query: roles_list = {
            page: page,
            limit: pageLimit,
            sortBy: sortBy,
            sortType: sortType
        }
        dispatch(setLoading());
        await RolesApi.list(query).then((res) => {
            if (res.status < 300) {
                setData(res.data?.data?.items || [])
                setTotalItems(res.data?.data?.meta?.totalItems || 0)
            }
        }).catch((err) => {
            console.log(err)
        }).finally(() => {
            dispatch(unsetLoading());
        })
    }, [page, pageLimit, sortBy, sortType])

    useEffect(() => {
        handleGetData();
    }, [handleGetData])

    return {
        renderData,
        page,
        pageLimit,
        sortBy,
        sortType,
        headCell,
        totalItems,
        data,
        handleRequestSort,
        setPageLimit,
        setPage,
        checkPermit
    }
}